import { Card } from "@/components/ui/card"

export function ShopCardSkeleton() {
  return (
    <Card className="relative bg-card border border-border rounded-[2.5rem] overflow-hidden min-h-[38svh] md:min-h-[46svh] animate-pulse">
      <div className="h-full w-full bg-muted" />
    </Card>
  )
}

export function ListingCardSkeleton() {
  return (
    <div className="bg-card border border-border rounded-[2.5rem] overflow-hidden animate-pulse">
      <div className="aspect-[4/3] bg-muted" />
      <div className="p-4 space-y-3">
        <div className="h-6 bg-muted rounded w-3/4" />
        <div className="h-4 bg-muted rounded w-1/2" />
        <div className="h-8 bg-muted rounded w-1/3" />
      </div>
    </div>
  )
}

export function TransactionSkeleton() {
  return (
    <div className="flex items-center justify-between py-3 animate-pulse">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 bg-muted rounded-full" />
        <div className="space-y-2">
          <div className="h-4 bg-muted rounded w-24" />
          <div className="h-3 bg-muted rounded w-16" />
        </div>
      </div>
      <div className="h-5 bg-muted rounded w-16" />
    </div>
  )
}
